import { FormGroup } from '@angular/forms';
import { SelectOption } from '@app/interfaces/sys/dict';
import { STData } from '@app/interfaces/sys/st';
import dayjs from 'dayjs';

const BBU_TECHNOLOGY: SelectOption[] = [
    {
        value: 'GSM',
        label: 'GSM'
    },
    {
        value: 'WCDMA',
        label: 'WCDMA'
    },
    {
        value: 'LTE',
        label: 'LTE'
    },
    {
        value: '5G',
        label: '5G'
    },
    {
        value: 'NR',
        label: 'NR'
    },
];
const PHYSICAL_SERVER_STATUS: SelectOption[] = [
    {
        value: 'Installed',
        label: 'Installed'
    }
];
const TEST_EQUIPMENT_STATUS: SelectOption[] = [
    {
        value: 'In use',
        label: 'In use'
    }
];
const SFP_TYPE: SelectOption[] = [
    {
        value: '1 Gbit/s SFP',
        label: '1 Gbit/s SFP'
    }
];
const SFP_WORKING_MODE: SelectOption[] = [
    {
        value: 'multimode',
        label: 'multimode'
    },
    {
        value: 'singlemode',
        label: 'singlemode'
    }
];
const SFP_CONNECTOR: SelectOption[] = [
    {
        value: 'LC',
        label: 'LC'
    },
    {
        value: 'RJ45',
        label: 'RJ45'
    },
    {
        value: 'MTP',
        label: 'MTP'
    }
];
const SFP_STATUS: SelectOption[] = [
    {
        value: 'Installed',
        label: 'Installed'
    },
    {
        value: 'damaged',
        label: 'damaged'
    },
    {
        value: 'Lost',
        label: 'Lost'
    }
];
const SWITCH_ROUTER_STATUS: SelectOption[] = PHYSICAL_SERVER_STATUS;
const TEST_SIM_STATUS: SelectOption[] = PHYSICAL_SERVER_STATUS;
const SOFTWARE_TOOL_STATUS: SelectOption[] = TEST_EQUIPMENT_STATUS;
const BBU_STATUS: SelectOption[] = PHYSICAL_SERVER_STATUS;
const RF_SWITCH_SPLITTER_STATUS: SelectOption[] = PHYSICAL_SERVER_STATUS;
const ATTENUATOR_PRODUCT_TYPE: SelectOption[] = [
    {
        value: 'Coax',
        label: 'Coax'
    }
];
const GPS_CONNECTOR_TYPE: SelectOption[] = [
    {
        value: 'TNC',
        label: 'TNC'
    }
];
const GPS_CONNECTOR_STATUS: SelectOption[] = PHYSICAL_SERVER_STATUS;
const SHIELD_CHAMBER_BOX_STATUS: SelectOption[] = PHYSICAL_SERVER_STATUS;
const RACK_STATUS: SelectOption[] = PHYSICAL_SERVER_STATUS;
const CLOUD_CLUSTER_PLATFORM_TYPE: SelectOption[] = [
    {
        value: 'Windriver',
        label: 'Windriver'
    },
    {
        value: 'openshift',
        label: 'openshift'
    }
];
const CLOUD_CLUSTER_PLATFORM_STATUS: SelectOption[] = PHYSICAL_SERVER_STATUS;
const OCU_ODU_TYPE: SelectOption[] = [
    {
        value: 'O-CU',
        label: 'O-CU'
    }
];
const OCU_ODU_STATUS: SelectOption[] = PHYSICAL_SERVER_STATUS;
const BBU_ACCESSORY_TYPE: SelectOption[] = [
    {
        value: 'LTE',
        label: 'LTE'
    },
    {
        value: 'WCDMA',
        label: 'WCDMA'
    },
    {
        value: '5G',
        label: '5G'
    },
    {
        value: 'NR',
        label: 'NR'
    }
];

function getRemainingDays(date: string): string {
    const licExpireDate = dayjs(date).startOf('d');
    const currentDate = dayjs().startOf('d');
    const diff = licExpireDate.diff(currentDate, 'day');
    return diff < 0 ? 'Expired' : diff.toString();
}

export default {
    data: [
        {
            title: 'Physical Server',
            type: 'PHYSICAL_SERVER',
            category: 'PHYSICAL',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'HostName', index: 'hostName' },
                { title: 'SN ', index: 'sn', width: '120px' },
                { title: 'NIC info', index: 'nicInfo' },
                { title: 'Storage', index: 'storage', width: '70px' },
                { title: 'BMC IP Address / VLAN', index: 'bmcIpAddressVlan', width: '180px' },
                { title: 'OAM IP Address / VLAN', index: 'oamIpAddressVlan', width: '180px' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'OOB PS', index: 'oobPs' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo', required: true },
                { label: 'HostName', key: 'hostName' },
                { label: 'SN ', key: 'sn', required: true },
                { label: 'NIC info', key: 'nicInfo' },
                { label: 'Storage', key: 'storage' },
                { label: 'BMC IP Address / VLAN', key: 'bmcIpAddressVlan' },
                { label: 'OAM IP Address / VLAN', key: 'oamIpAddressVlan' },
                { label: 'Status', key: 'status', type: 'autocomplete', options: PHYSICAL_SERVER_STATUS },
                { label: 'OOB PS', key: 'oobPs' },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder', width: '100px' },
            ],
        },
        {
            title: 'Server Accessory',
            type: 'SERVER_ACCESSORY',
            category: 'ACCESSORY',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty' },
                { title: 'Size', index: 'size' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'SN ', key: 'sn', required: true },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Size', key: 'size' },
                { label: 'Status', key: 'status' },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'Test Equipment',
            type: 'TEST_EQUIPMENT',
            category: 'ACCESSORY',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty' },
                { title: 'RF Port', index: 'rfPort' },
                { title: 'IP Address', index: 'ipAddress' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'SN ', key: 'sn', required: true },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'RF Port', key: 'rfPort', type: 'input_number' },
                { label: 'IP Address', key: 'ipAddress' },
                { label: 'Status', key: 'status', type: 'autocomplete', options: TEST_EQUIPMENT_STATUS },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'SFP',
            type: 'SFP',
            deleteTypeName: 'SFP',
            category: 'ACCESSORY',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '140px' },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty' },
                { title: 'Type', index: 'type' },
                { title: 'Speed', index: 'speed' },
                { title: 'Working Mode', index: 'workingMode', width: '120px' },
                { title: 'Wavelength', index: 'wavelenght' },
                { title: 'Connector', index: 'connector' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'SN ', key: 'sn', required: true },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Type', key: 'type', type: 'autocomplete', options: SFP_TYPE },
                { label: 'Speed', key: 'speed' },
                { label: 'Working Mode', key: 'workingMode', type: 'autocomplete', options: SFP_WORKING_MODE },
                { label: 'Wavelength', key: 'wavelenght' },
                { label: 'Connector', key: 'connector', type: 'autocomplete', options: SFP_CONNECTOR },
                { label: 'Status', key: 'status', type: 'autocomplete', options: SFP_STATUS },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'Switch Router',
            type: 'SWITCH_ROUTER',
            category: 'PHYSICAL',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'SN ', key: 'sn', required: true },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Status', key: 'status', type: 'autocomplete', options: SWITCH_ROUTER_STATUS },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'Test SIM',
            type: 'TEST_SIM',
            deleteTypeName: 'test SIM',
            category: 'ACCESSORY',
            tableColumns: [
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'Operator', index: 'operator' },
                { title: 'ICCID', index: 'iccid' },
                { title: 'Qty', index: 'qty' },
                { title: 'SIM Size', index: 'simSize' },
                { title: 'MSISDN', index: 'msisdn' },
                { title: 'SIM Number', index: 'simNumber' },
                { title: 'Status', index: 'status', width: '80px' },
            ],
            field: [
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'Operator', key: 'operator' },
                { label: 'ICCID', key: 'iccid' },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'SIM Size', key: 'simSize' },
                { label: 'MSISDN', key: 'msisdn', required: true },
                { label: 'SIM Number', key: 'simNumber' },
                { label: 'Status', key: 'status', type: 'autocomplete', options: TEST_SIM_STATUS },
            ],
        },
        {
            title: 'Software Tools',
            type: 'SOFTWARE_TOOL',
            deleteTypeName: 'software tool',
            category: 'SOFTWARE',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'Key', index: 'key', required: true },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty' },
                { title: 'License Expiry Date', index: 'licExpireDate', width: '150px', type: 'date', dateFormat: 'YYYY-MM-dd' },
                { title: 'Remaining Days', index: 'remainingDays', width: '130px',
                    format: (item: STData) => {
                        const licExpireDate = item.licExpireDate;
                        return licExpireDate ? getRemainingDays(licExpireDate) : '';
                    },
                },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Used by', index: 'user' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'Key', key: 'key', required: true },
                { label: 'SN ', key: 'sn' },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'License Expiry Date', key: 'licExpireDate', type: 'date',
                    changeFn: (licExpireDate: string, validateForm: FormGroup) => {
                        const value = getRemainingDays(licExpireDate);
                        validateForm.get('remainingDays')?.setValue(value);
                    },
                },
                { label: 'Status', key: 'status', type: 'autocomplete', options: SOFTWARE_TOOL_STATUS},
                { label: 'Used by', key: 'user', required: true },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'BBU',
            type: 'BBU',
            deleteTypeName: 'BBU',
            category: 'PHYSICAL',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty' },
                { title: 'Technology', index: 'technology' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'SN ', key: 'sn', required: true },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Technology', key: 'technology', type: 'autocomplete', options: BBU_TECHNOLOGY},
                { label: 'Status', key: 'status', type: 'autocomplete', options: BBU_STATUS },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'BBU Accessory',
            type: 'BBU_ACCESSORY',
            deleteTypeName: 'BBU accessory',
            category: 'ACCESSORY',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '140px' },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty' },
                { title: 'Technology', index: 'technology' },
                { title: 'Status', index: 'status' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'SN', key: 'sn', required: true },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Technology', key: 'technology', type: 'autocomplete', options: BBU_ACCESSORY_TYPE },
                { label: 'Status', key: 'status' },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'RF Accessory',
            type: 'RF_ACCESSORY',
            deleteTypeName: 'RF accessory',
            category: 'ACCESSORY',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '140px' },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty' },
                { title: 'Connector Interface', index: 'connectorInterface', width: '160px' },
                { title: 'Product Type', index: 'productType' },
                { title: 'Frequency', index: 'frequency' },
                { title: 'Input Power, PEP, maximum', index: 'inputPowerPepMaximum', width: '200px' },
                { title: 'Input Power, RMS, maximum', index: 'inputPowerRmsMaximum', width: '200px' },
                { title: 'Attenuation', index: 'attenuation' },
                { title: 'Attenuation Tolerence', index: 'attenuationTolerence', width: '180px' },
                { title: 'Impedence', index: 'impedence' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'SN ', key: 'sn' },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Connector Interface', key: 'connectorInterface', width: '140px' },
                { label: 'Product Type', key: 'productType' },
                { label: 'Frequency', key: 'frequency' },
                { label: 'Input Power, PEP, maximum', key: 'inputPowerPepMaximum', type: 'input_number'},
                { label: 'Input Power, RMS, maximum', key: 'inputPowerRmsMaximum', type: 'input_number' },
                { label: 'Attenuation', key: 'attenuation', type: 'input_number' },
                { label: 'Attenuation Tolerence', key: 'attenuationTolerence' },
                { label: 'Impedence', key: 'impedence' },
                { label: 'Status', key: 'status' },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'RF Switch Splitter',
            type: 'RF_SWITCH_SPLITTER',
            deleteTypeName: 'RF switch splitter',
            category: 'PHYSICAL',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty' },
                { title: 'Input Port', index: 'inputPort' },
                { title: 'Output Port', index: 'outputPort' },
                { title: 'Connector Interface', index: 'connectorInterface', width: '160px' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
                { title: 'Frequency', index: 'frequency' },
                { title: 'Power', index: 'power' },
                { title: 'Low PIM', index: 'lowPIM' },
                { title: 'Insertion Loss', index: 'insertionLoss', width: '120px' },
                { title: 'Impedence', index: 'impedence' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'SN ', key: 'sn' },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Input Port', key: 'inputPort', type: 'input_number' },
                { label: 'Output Port', key: 'outputPort', type: 'input_number' },
                { label: 'Connector Interface', key: 'connectorInterface' },
                { label: 'Status', key: 'status', type: 'autocomplete', options: RF_SWITCH_SPLITTER_STATUS },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
                { label: 'Frequency', key: 'frequency', required: true },
                { label: 'Power', key: 'power' },
                { label: 'Low PIM', key: 'lowPIM' },
                { label: 'Insertion Loss', key: 'insertionLoss' },
                { label: 'Impedence', key: 'impedence' },
            ],
        },
        {
            title: 'Attenuator',
            type: 'ATTENUATOR',
            category: 'ACCESSORY',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty' },
                { title: 'Connector Interface', index: 'connectorInterface', width: '160px' },
                { title: 'Product Type', index: 'productType' },
                { title: 'Frequency', index: 'frequency' },
                { title: 'Input Power, PEP, maximum', index: 'inputPowerPepMaximum', width: '220px' },
                { title: 'Input Power, RMS, maximum', index: 'inputPowerRmsMaximum', width: '220px' },
                { title: 'Attenuation', index: 'attenuation' },
                { title: 'Attenuation Tolerence', index: 'attenuationTolerence', width: '160px' },
                { title: 'Impedence', index: 'impedence' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'SN ', key: 'sn' },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Connector Interface', key: 'connectorInterface' },
                { label: 'Product Type', key: 'productType', type: 'autocomplete', options: ATTENUATOR_PRODUCT_TYPE },
                { label: 'Frequency', key: 'frequency' },
                { label: 'Input Power, PEP, maximum', key: 'inputPowerPepMaximum', type: 'input_number' },
                { label: 'Input Power, RMS, maximum', key: 'inputPowerRmsMaximum', type: 'input_number' },
                { label: 'Attenuation', key: 'attenuation', type: 'input_number' },
                { label: 'Attenuation Tolerence', key: 'attenuationTolerence' },
                { label: 'Impedence', key: 'impedence' },
                { label: 'Status', key: 'status' },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'GPS Amplifier',
            type: 'GPS_AMPLIFIER',
            deleteTypeName: 'GPS amplifier',
            category: 'ACCESSORY',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty' },
                { title: 'Frequency Range', index: 'frequencyRange', width: '140px' },
                { title: 'Gain', index: 'gain' },
                { title: 'Impedence', index: 'impedence' },
                { title: 'Connector Type', index: 'connectorType', width: '140px' },
                { title: 'Noise Figure', index: 'noiseFigure' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'SN ', key: 'sn' },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Frequency Range', key: 'frequencyRange' },
                { label: 'Gain', key: 'gain' },
                { label: 'Impedence', key: 'impedence' },
                { label: 'Connector Type', key: 'connectorType', type: 'autocomplete', options: GPS_CONNECTOR_TYPE },
                { label: 'Noise Figure', key: 'noiseFigure' },
                { label: 'Status', key: 'status', type: 'autocomplete', options: GPS_CONNECTOR_STATUS },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'Shield Chamber Box',
            type: 'SHIELD_CHAMBER_BOX',
            category: 'PHYSICAL',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'SN ', index: 'sn', width: '60px' },
                { title: 'Qty', index: 'qty', width: '60px' },
                { title: 'Dimension', index: 'dimension' },
                { title: 'Frequency / Shielding effectiveness (dB', index: 'frequencyShieldingEffectivenessDb', width: '270px' },
                { title: 'RF Connector Interface', index: 'rfConnectorInterface', width: '170px' },
                { title: 'Ethernet Port', index: 'ethernetPort', width: '110px' },
                { title: 'USB Port', index: 'usbPort' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'SN ', key: 'sn' },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Dimension', key: 'dimension' },
                { label: 'Frequency / Shielding effectiveness (dB', key: 'frequencyShieldingEffectivenessDb' },
                { label: 'RF Connector Interface', key: 'rfConnectorInterface' },
                { label: 'Ethernet Port', key: 'ethernetPort', type: 'input_number' },
                { label: 'USB Port', key: 'usbPort' },
                { label: 'Status', key: 'status', type: 'autocomplete', options: SHIELD_CHAMBER_BOX_STATUS },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'Rack',
            type: 'RACK',
            category: 'PHYSICAL',
            tableColumns: [
                { title: 'Manufacturer', index: 'made' },
                { title: 'Model / Part No.', index: 'modelPartNo', width: '130px' },
                { title: 'Qty', index: 'qty', width: '60px' },
                { title: 'Size ', index: 'size' },
                { title: 'Unit', index: 'unit' },
                { title: 'Power', index: 'power' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor order', index: 'vendorOrder', width: '120px' },
            ],
            field: [
                { label: 'Manufacturer', key: 'made' },
                { label: 'Model / Part No.', key: 'modelPartNo' },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Size ', key: 'size', type: 'input_number' },
                { label: 'Unit', key: 'unit', type: 'input_number' },
                { label: 'Power', key: 'power', type: 'input_number', required: true },
                { label: 'Status', key: 'status', type: 'autocomplete', options: RACK_STATUS },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor order', key: 'vendorOrder' },
            ],
        },
        {
            title: 'Cloud Cluster Platform',
            type: 'CLOUD_CLUSTER_PLATFORM',
            category: 'SOFTWARE',
            tableColumns: [
                { title: 'Type', index: 'type' },
                { title: 'Version', index: 'version' },
                { title: 'Qty', index: 'qty', width: '60px' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor', index: 'vendor' },
            ],
            field: [
                { label: 'Type', key: 'type', type: 'autocomplete', options: CLOUD_CLUSTER_PLATFORM_TYPE },
                { label: 'Version', key: 'version' },
                { label: 'Qty', key: 'qty', type: 'input_number' },
                { label: 'Status', key: 'status', type: 'autocomplete', options: CLOUD_CLUSTER_PLATFORM_STATUS },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor', key: 'vendor' },
            ],
        },
        {
            title: 'CNF(VNF)',
            type: 'OCU_ODU',
            deleteTypeName: 'CNF(VNF)',
            category: 'SOFTWARE',
            tableColumns: [
                { title: 'Type', index: 'type' },
                { title: 'Version', index: 'version' },
                { title: 'Configuration', index: 'configuration', width: '110px' },
                { title: 'Virtual Machine', index: 'virtualMachine', width: '120px' },
                { title: 'Status', index: 'status', width: '80px' },
                { title: 'Purchasing order', index: 'telusPo' },
                { title: 'Vendor', index: 'vendor' },
            ],
            field: [
                { label: 'Type', key: 'type', type: 'autocomplete', options: OCU_ODU_TYPE },
                { label: 'Version', key: 'version' },
                { label: 'Configuration', key: 'configuration' },
                { label: 'Virtual Machine', key: 'virtualMachine' },
                { label: 'Status', key: 'status', type: 'autocomplete', options: OCU_ODU_STATUS },
                { label: 'Purchasing order', key: 'telusPo' },
                { label: 'Vendor', key: 'vendor' },
            ]
        }
    ],
    getRemainingDays
};
